module.exports = __webpack_public_path__ + "images/img-cMGzkoH.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/offers.jpg
// module id = 2004
// module chunks = 0